module.exports = __webpack_public_path__ + "img/arrow.95f3ddf6.svg";